import Layout from '@/layout';

export default {
  weight: 3,
  path: '/classification',
  component: Layout,
  redirect: '/classificationList',
  name: 'classification',
  meta: { title: '分类管理', icon: 'el-icon-s-finance' },
  children: [
    {
      path: 'classificationList',
      name: 'classificationList',
      component: () => import('@/views/classification/classificationList'),
      meta: { title: '一级分类', icon: 'el-icon-s-data' },
    },
    {
      path: 'classificationDetails',
      name: 'classificationDetails',
      component: () => import('@/views/classification/classificationDetails'),
      meta: {
        title: '一级分类详情',
        icon: 'el-icon-s-data',
        activeMenu: '/classification/classificationList',
      },
      hidden: true,
    },

    {
      path: 'classificationTwoList',
      name: 'classificationTwoList',
      component: () => import('@/views/classification/classificationTwoList'),
      meta: { title: '二级分类', icon: 'el-icon-s-data' },
    },

    {
      path: 'classificationDetailsTwo',
      name: 'classificationDetailsTwo',
      component: () => import('@/views/classification/classificationDetailsTwo'),
      meta: {
        title: '添加二级分类',
        icon: 'el-icon-s-data',
        activeMenu: '/classification/classificationList',
      },
      hidden: true,
    },

    {
      path: 'setContent',
      name: 'setContent',
      component: () => import('@/views/classification/setContent'),
      meta: {
        title: '设置文案',
        icon: 'el-icon-s-data',
        activeMenu: '/classification/classificationList',
      },
      hidden: true,
    },

    {
      path: 'setImageSplicing',
      name: 'setImageSplicing',
      component: () => import('@/views/classification/setImageSplicing'),
      meta: {
        title: '设置图片',
        icon: 'el-icon-s-data',
        activeMenu: '/classification/classificationList',
      },
      hidden: true,
    },
  ],
};
